<ng-container *transloco="let t">
    <h2 mat-dialog-title>{{ t("auth.account-verification.dialogTitle") }}</h2>
    <mat-dialog-content>
        <p>{{ t("auth.account-verification.securityCodeNotice") }}</p>
        <code-input
            appIgnorePasswordManagers
            [isCodeHidden]="false"
            [codeLength]="6"
            (codeChanged)="onCodeChanged($event)"
            (codeCompleted)="onCodeCompleted($event)"
        ></code-input>
    </mat-dialog-content>
    <mat-dialog-actions align="end">
        <button mat-button (click)="cancel()">
            {{ t("application.dialogs.actions.cancel") | uppercase }}
        </button>
        <button mat-button mat-dialog-close [disabled]="!complete">
            {{ t("shared.submit") | uppercase }}
        </button>
    </mat-dialog-actions>
</ng-container>
